// Simple UUID generator with crypto fallback
const generateUuid = () => {
	if (typeof crypto !== "undefined" && crypto.randomUUID) {
		return crypto.randomUUID();
	}
	const rnd = (len) => Array.from({ length: len }, () => Math.floor(Math.random() * 16).toString(16)).join("");
	return `${rnd(8)}-${rnd(4)}-${rnd(4)}-${rnd(4)}-${rnd(12)}`;
};

export const getVisitorId = () => {
	try {
		const key = "al_vid";
		let id = localStorage.getItem(key);
		if (!id) {
			id = generateUuid();
			localStorage.setItem(key, id);
		}
		return id;
	} catch (_) {
		return generateUuid();
	}
};

export const getSessionId = () => {
	try {
		const key = "al_sid";
		let id = sessionStorage.getItem(key);
		if (!id) {
			id = generateUuid();
			sessionStorage.setItem(key, id);
		}
		return id;
	} catch (_) {
		return generateUuid();
	}
};
